<section class="hosts" *ngIf="showSection">
    <div class="container">
        <h2 class="hosts__title">{{ title }}</h2>
        <ng-container *ngFor="let host of hosts">
            <app-host [host]="host"></app-host>
        </ng-container>
        <div *ngIf="showFinraDisclosure" class="hosts__finraText" [innerHTML]="finraDisclosure"></div>
        <div class="hosts__button-wrapper">
            <button [disabled]="ctaDisabled" (click)="register()" class="button button--primary hosts__button">{{ ctaButtonText }}</button>
        </div>
    </div>
</section>
